import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";

import LoginPage from "@/pages/LoginPage";
import AdminLayout from "@/pages/admin/AdminLayout";
import DashboardPage from "@/pages/admin/DashboardPage";
import CoursesListPage from "@/pages/admin/CoursesListPage";
import CourseEditorPage from "@/pages/admin/CourseEditorPage";
import CandidatesPage from "@/pages/admin/CandidatesPage";
import BrandingPage from "@/pages/admin/BrandingPage";
import LandingPage from "@/pages/LandingPage";
import LearnPage from "@/pages/LearnPage";
import CertificatePage from "@/pages/CertificatePage";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-sm font-mono text-muted-foreground">
        Loading...
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/learn/:token" element={<LearnPage />} />
          <Route path="/certificate/:token" element={<CertificatePage />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="courses" element={<CoursesListPage />} />
            <Route path="courses/new" element={<CourseEditorPage />} />
            <Route path="courses/:id" element={<CourseEditorPage />} />
            <Route path="candidates" element={<CandidatesPage />} />
            <Route path="branding" element={<BrandingPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
